import React, {Component} from "react";
import "./EditVirtualChildren.scss";
import {
    CardBody,
    EditableList,
    Button
} from "gd-react";
import GridDuck from "gridduck";
import GdModal from "../../components/GdModal/GdModal";

class EditVirtualChildrenModal extends Component {

    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.getActiveList = this.getActiveList.bind(this);
        this.getAvailableList = this.getAvailableList.bind(this);
        this.childrenChanged = this.childrenChanged.bind(this);

        this.state = {
            wide: true,
            deleteConfirmation: '',
            children: [],
            itemsToAddRemove: []
        }

        this.modalClosed = false;
    }

    closeModal() {
        this.modalClosed = true;
        this.props.onClose();
    }

    async saveChanges() {
        let assetUpdatePromises = [];
        this.state.itemsToAddRemove.itemsToAdd.forEach(asset => assetUpdatePromises.push(asset.setVirtualParentAsset(this.props.item.id)));
        this.state.itemsToAddRemove.itemsToRemove.forEach(asset => assetUpdatePromises.push(asset.setVirtualParentAsset(null)));
        const updateAssets = await Promise.all(assetUpdatePromises);
        return updateAssets;
    }

    childrenChanged(a, b, itemsToAddRemove) {
        this.setState({itemsToAddRemove: itemsToAddRemove});
    }

    async getAvailableList(retrievalParams) {
        let assets = await GridDuck.getAssets(retrievalParams);
        assets.list = assets.list.filter(a => a.id !== this.props.item.id);
        assets.total -= 1;
        return assets;
    }

    getActiveList(retrievalParams) {
        return GridDuck.getAssets(retrievalParams);
    }

    render() {
        return (
            <GdModal
                title={this.props.item.name + ' Merged Devices'}
                open={this.props.open}
                wide={true}
                contentLabel={'Edit Merged Device'}
                footer={<div className={'button-container'}>
                    <Button
                        key={'next-butt'}
                        onClick={this.saveChanges}
                        label={"Save Changes"}
                        color={"gd-brand"}
                    />
                </div>}
                onClose={this.closeModal}>
                <CardBody wide additionalclasses={'no-padding'}>
                    <EditableList
                        isEditing={true}
                        activeFilters={[
                            {
                                field: 'virtualParentAsset',
                                value: this.props.item.id
                            },
                            {
                                field: 'showVirtualMergedChildren',
                                value: true
                            }
                        ]}
                        availableFilters={[{field: 'siteId', value: this.props.item.siteId}, {
                            field: 'showVirtualMergedChildren',
                            value: true
                        }]}
                        key={1}
                        onChange={this.childrenChanged}
                        noCancel={true}
                        noSave
                        getActiveList={this.getActiveList}
                        getAvailableList={this.getAvailableList}
                    />
                </CardBody>
            </GdModal>
        )
    }

}

export default EditVirtualChildrenModal;